// extracted by mini-css-extract-plugin
module.exports = {"container":"registration_container__1-YTx","section":"registration_section__21qJ1","form":"registration_form__33eiK","link":"registration_link__1oW5h"};